import axiosInstance from "@/api/axiosInstance";
import { CreateBulkHoursRequest, CreateBulkHoursResponse } from "./types";

export const createBulkHours = async (
  request: CreateBulkHoursRequest,
): Promise<CreateBulkHoursResponse> => {
  const response = await axiosInstance.post<CreateBulkHoursResponse>(
    "/api/capex/hours/bulk",
    request,
  );
  return response.data;
};
